import React from 'react'
import styles from 'styled-components'

const Container = styles.div`
	position: relative;
	font-family: 'Orbitron', sans-serif;
	color: black;
	height: 60px;
	width: 320px;
`

const Digit = React.memo(styles.div`
	display: inline-block;
	width: ${({ children }) => (children === ':' ? '20px' : '40px')};
	text-align: center;
`)

const Digits = styles.div`
	display: inline-block;
	font-size: 60px;
`

const Meridiem = React.memo(styles.div`
	position: absolute;
	right: 0;
	font-size: 20px;
	letter-spacing: 5px;
`)

const Time = () => {
	const [time, setTime] = React.useState(
		new Date()
	);

	React.useEffect(() => {
		setInterval(() => {
			setTime(new Date())
		}, 1000)
	}, [])

	const getTime = (type) => {
		const timeArray = time[`get${type}`]()
			.toString()
			.split('')
		if (timeArray.length === 1) {
			timeArray.unshift('0')
		}
		return timeArray
	}

	const digits = [
		...getTime('Hours'),
		':',
		...getTime('Minutes'),
		':',
		...getTime('Seconds'),
	]

	const meridiem = time.getHours() > 12 ? 'PM' : 'AM'

	return (
		<Container>
			<Digits>
				{digits.map((digit, index) => (
					<Digit key={index}>{digit}</Digit>
				))}
			</Digits>
			<Meridiem>{meridiem}</Meridiem>
		</Container>
	)
}

export default Time